export const ProjectTwcGeDetailFormKeys = {
  NOMINATED_STAFF: 'projectUserProfileId',
  POSITION: 'position',
  GRADE: 'grade',
  PROPOSED_AS: 'proposedAs',
  RESPONSIBILITY: 'responsibility',
  TRAINING_EVIDENCE: 'trainingEvidence',
  PM_COMMENTS: 'pmComments',
  EM_COMMENTS: 'emComments',
  HOE_COMMENTS: 'hoeComments',
  ATTACHED_CV: 'tempCv',
};
